import { BCMSRecord, BCMSStateManagerCRUD, useBCMSContext } from "@bcm-dev/bcms-vite";
import ImportACHPage, { getDefaultData, getDefaultUI } from "components/pages/ImportACHPage";
import Classes, { ParticipantImportTemplate } from "model";

/**
 * @name CaptureParticipantImportTemplatesNACHAFileImported
 * @returns {React.Component}
 * @description 
 * This capture is used in the following capture groups:
 * "ACH Import File (Participants)" (abi22).
 */
export default function CaptureParticipantImportTemplatesNACHAFileImported(props) {
    const context = useBCMSContext();
    BCMSRecord.globalControllerFor(Classes, context);
    
    let allTemplates = getDefaultData().participantImportTemplatesWidgetData.importTemplates;
    const template = ParticipantImportTemplate.init({ 
        id: ParticipantImportTemplate.nextID(),
        templateName: "Payroll_Participants", 
        participantName: "1",
        nickname: "2",
        institutionName: "3",
        routing: "4",
        number: "5",
        accountType: "6",
        uniqueID: "7",
        status: "8",
        group: "9",
        discretionaryData: "10"
    });
    allTemplates = [ ...allTemplates, template ];

    const data = BCMSStateManagerCRUD.init(getDefaultData())
    .update([ "participantImportTemplatesWidgetData", "importTemplates" ], allTemplates)
    .update([ "importParticipantsCSVFileWidgetData", "importTemplates" ], allTemplates)
    .update([ "importParticipantsNACHAFileWidgetData", "selectedTemplate" ], "select")
    .submit();

    const ui = BCMSStateManagerCRUD.init(getDefaultUI())
    .update([ "importParticipantsCSVFileWidgetUI", "isFileUploaded" ], true)
    .update([ "importParticipantsNACHAFileWidgetUI", "isFileUploaded" ], true)
    .update([ "importParticipantsNACHAFileWidgetUI", "showFileUploadedBanner" ], true)
    .submit();

    return <ImportACHPage data={ data } ui={ ui } className="for-capture"/>;
}